<div id="leave-planner">
  <form [formGroup]="leaveForm">
    <div class="row">
      <div class="col">
        <div><label>State</label></div>
        <div class="select">
          <select formControlName="state_name">
            @for (state of stateList; track state) {
            <option value="{{ state.name }}">{{ state.name }}</option>
            }
          </select>
        </div>
      </div>
      <div class="col">
        <div>
          <label>Topic of Interest </label>
          <span style="position: absolute; right: 10px; top: 5px">
            <ng-content select="[moreOption]"> </ng-content
          ></span>
        </div>

        <div class="select">
          <select formControlName="leave_reason">
            @for (leave of leaveReasons; track leave) {
            <option value="{{ leave.name }}">{{ leave.name }}</option>
            }
          </select>
        </div>
      </div>

      <div class="col-12">
        <div style="margin-right: 10px" class="is-pulled-right">
          <input
            type="button"
            class="button is-rounded"
            (click)="submitForm()"
            value="Submit"
          />
        </div>
      </div>
    </div>
  </form>

  <div
    id="chat-list"
    class="scroll-bar list-overflow scrollUserandGroup"
    appInfiniteScroll
  >
    <pagination-loader
      [showFetchLoader]="showPaginateSpinner"
    ></pagination-loader>
    @for (data of resultData; track data; let i = $index) {
    <div class="answer-list" id="question{{ data?.sequence_id }}">
      <div class="answer">
        <label><br />{{ data.question }}</label>
        <div class="answer-content" [innerHTML]="data.bot_answer"></div>
        <div class="comment-form">
          <label class="label">Have I answered your question?</label><br />
          <button
            type="button"
            class="button is-rounded"
            (click)="submitFeedForm()"
            style="margin-right: 10px"
          >
            Yes
          </button>
          <button
            type="button"
            class="button is-rounded"
            (click)="showFeedbackform()"
          >
            No
          </button>
          @if (isActiveFeedback) {
          <div class="comments-field">
            <form [formGroup]="commentForm">
              <div class="field">
                <textarea
                  class="textarea"
                  rows="3"
                  cols="35"
                  formControlName="comment"
                  (keyup)="onKeypressEvent($event)"
                  placeholder="Enter your comments"
                ></textarea>
              </div>
              <div class="form-btns">
                <!-- <button class="btn btn-outline-primary" (click)="cancelComment()">Cancel</button> -->
                <button
                  class="button is-rounded is-right"
                  [disabled]="commentForm.invalid"
                  (click)="saveComment(data)"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
          }
          <!-- <div class="triangle-up"></div> -->
          <!-- <form  [formGroup]="commentForm">
            <label class="label">Did i answered your question?</label>
            <input type="button" class="button is-rounded" (click)="submitForm()"  value="Yes"> &nbsp;&nbsp;
            <input type="button" class="button is-rounded"   value="No" appToggle>
            <textarea class="textarea comment-area-box" rows="3" cols="35" formControlName="comment"   placeholder="Enter your comment"></textarea>
          </form> -->
        </div>
        <div class="answer-header">
          <span style="visibility: hidden">
            {{ data.created_at | date : "MMM d, y, h:mm a" }}</span
          >
          <span class="menu-list">
            <ul>
              <li
                (click)="refresh(i)"
                class="has-tooltip-top"
                data-tooltip="Refresh"
                placement="top"
              >
                <i class="fa fa-refresh" aria-hidden="true"></i>
              </li>
              <li class="has-tooltip-top" data-tooltip="Audio" placement="top">
                <app-toggle-icon
                  [icons]="volumeicons"
                  [defaultState]="'off'"
                  (iconState)="speakText($event, data.bot_answer)"
                ></app-toggle-icon>
              </li>
              <li
                (click)="generateAudio(data)"
                class="has-tooltip-top"
                data-tooltip="Audio File"
                placement="top"
              >
                <i class="fa fa-file-audio-o" aria-hidden="true"></i>
              </li>
              <li>
                <div class="dropdown is-hoverable">
                  <div
                    class="dropdown-trigger"
                    class="has-tooltip-top"
                    data-tooltip="Pin"
                    placement="top"
                  >
                    <i class="fa fa-thumb-tack" aria-hidden="true"></i>
                  </div>
                  <div class="dropdown-menu" role="menu">
                    <div class="dropdown-content">
                      <div class="dropdown-item">
                        <li (click)="PingedChat(data)">Create a new pin</li>
                        <li>Add to existing pin</li>
                        <!-- <li (click)="openDialog(data)">Create a file</li>
                        <li>Create a audio file</li>
                        <li class="disabled">Create a video file</li> -->
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li
                (click)="openDialog(data)"
                class="has-tooltip-top"
                data-tooltip="Generate Document"
                placement="top"
              >
                <i class="fa fa-file-text-o" aria-hidden="true"></i>
              </li>
              <li
                (click)="copiedText(data)"
                class="has-tooltip-top"
                data-tooltip="Copy Text"
                placement="top"
              >
                <i class="fa fa-files-o" aria-hidden="true"></i>
              </li>
              <!-- <li (click)="downloadPDF(data)"><i class="fa fa-download" aria-hidden="true"></i></li> -->
            </ul>
          </span>
        </div>
      </div>
      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          margin-bottom: 30px;
        "
      >
        <span> {{ data.created_at | date : "MMM d, y, h:mm a" }}</span>
      </div>
    </div>
    }
  </div>
</div>
